import React from "react";
import { TextField } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';
import Button from '@material-ui/core/Button';
import { inputTypes } from '../../utils/inputTypes';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import AutoComplete from "../Layout/AutoComplete";
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
   container: {
      display: 'flex',
      flexWrap: 'wrap',
   },
   textField: {
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit,
      width: `${250}px`,
   },
   select: {
      textAlign: "left",
      width: `${250}px`,
   },
   formContainer: {
      textAlign: "center",
      marginLeft: "auto",
      marginRight: "auto",
      paddingTop: theme.spacing.unit * 4
   },
   buttonsContainer: {
      marginTop: theme.spacing.unit * 4
   },
   buttonsContainerButton: {
      marginBottom: theme.spacing.unit * 2
   },
   errorsContainer: {
      color: "red",
      textAlign: "left",
      marginLeft: theme.spacing.unit * 5,
      maxWidth: 250,
      fontSize: "0.8em"
      // marginTop: theme.spacing.unit * 2
   },
   inputContainer: {
      marginTop: `${theme.spacing.unit}px`
   },
   progress: {
    margin: theme.spacing.unit * 2,
   },
   progressText: {
    //margin: theme.spacing.unit * 2,
    fontSize: "0.7em"
   }
});

function renderSelect(value, id, label, options, handleChange, classes, disabled) {
  if(options === undefined || options.length ===0) {
    return (
      <div>
          Loading options... <CircularProgress className={classes.progress} size={20} />
      </div>
    )
  }
   return <div key={id} className={classes.inputContainer}>
      <FormControl>
         <InputLabel disabled={disabled} htmlFor={id}>{label}</InputLabel>
         <Select
            disabled={disabled}
            className={classes.select}
            value={value}
            onChange={handleChange}
            inputProps={{
               name: id,
               id: id,
            }}
         >
            {options.map(opt => {
              const isPrimitive = typeof(opt) === "string";
              const keyValue = isPrimitive ? opt : opt.id;
              const name = isPrimitive ? opt : opt.name;
              return <MenuItem key={keyValue} value={keyValue}>{name}</MenuItem>
          } )}

         </Select>
      </FormControl>
   </div>
}

class ModalForm extends React.Component {
  constructor() {
    super();
    this.state = {
      message:"",
    }
  }

  componentDidUpdate(prevProps) {
    if(this.props.formFields !== undefined) {
      const indx = this.props.formFields.findIndex(x => x.id === "locationId");
      if(indx > -1) {
        this.props.formFields[indx].update = undefined;
        return;
      }
    }
  }

  // Function that is used for "inhereting" the location from
  // Terminal AutoComplete to Location AutoComplete.
  // This sets the terminal's location id to the location input
  // and a "update" prop which tells the location
  // AutoComplete to update its display value.
  inherit = (selectedLocationId, locations, values) => {
    values['locationId'] = selectedLocationId;
    const indx = this.props.formFields.findIndex(x => x.id === "locationId");
    this.props.formFields[indx].update = "update";
    this.forceUpdate();
  }

  resetUpdate = (obj) => {
    this.props.resetUpdate();
  }

  disableInput = (input) => {
    if(input.disabled) {
      const disabled = input.disabled();
      return disabled;
    }
    return false;
  }


  render() {
    if (this.props.formFields == null || this.props.formFields.length === 0 || (this.props.locations && this.props.locations.length === 0))  {
      //if loading takes longer than 5 seconds, show message
      setTimeout(() => {
        this.setState({
          message:'Loading seems to take some time. Please wait or refresh your login'
        })
      }, 5000);
      return (
        <div>
          <CircularProgress className={this.props.classes.progress} style={{ marginLeft: '40%'}} size={50} />
          <p className={this.props.classes.progressText}>{this.state.message}</p>
        </div>
      )
    } else {
    return (
      <div>
        <Formik
          // dynamically set the initial values of the inputs
          initialValues={
            this.props.formFields.reduce((acc, curr) => {
              return { ...acc, [curr.name]: this.props.initialValues ? this.props.initialValues[curr.name] : "" }
            }, {})
          }
          validationSchema={() => this.props.validationSchema}
          onSubmit={(values, actions) => { this.props.handleSubmit(values, actions) }}
          render={({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            classes = this.props.classes
          },
            //helper function for TextField used for indicating an error
            textFieldHasError = (field) => touched[field] && errors[field] != null
          ) => (

              <div className={classes.formContainer}>

                <form onSubmit={(handleSubmit)}>
                  {this.props.formFields.map(i => {
                    
                    if (i.type === inputTypes.select) {
                      const disabled = this.disableInput(i);
                      return renderSelect(values[i.name], i.id, i.label, i.options, handleChange, classes, disabled);
                    }
                    // autocomplete (experimental)
                    if (i.type === inputTypes.autoComplete) {
                      let value = this.props.initialValues != null ? this.props.initialValues[i.name] : undefined;

                      return <AutoComplete resetUpdate={() => this.resetUpdate(i)} update={i.update} onChange={(locationId, entities) => { this.inherit(locationId, entities, values, this.props.formFields) }} initialEntityId={value} wrapperClass={classes.inputContainer} values={values} field={i} key={i.id} entitys={i.entities} />
                    }
                    // Text
                    else {
                      return <div className={classes.inputContainer} key={i.id}>
                        <TextField
                          error={textFieldHasError(i.name)}
                          id={i.id}
                          disabled={this.disableInput(i)}
                          label={i.label}
                          name={i.name}
                          value={values[i.name]}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          className={classes.textField}
                        />
                        <div className={classes.errorsContainer}>
                          {touched[i.name] && errors[i.name] && <div>{errors[i.name]}</div>}
                        </div>
                      </div>
                    }

                  })}
                  {this.props.children}

                  <div className={classes.buttonsContainer}>
                    <div className={classes.buttonsContainerButton}><Button disabled={isSubmitting} type="submit" variant="contained" color="primary">Save</Button></div>
                    <div className={classes.buttonsContainerButton}><Button onClick={this.props.handleCancel} disabled={isSubmitting} type="button" variant="outlined" color="primary">Cancel</Button></div>
                  </div>
                </form>
              </div>
            )}
        />
      </div>

)}}}

export default withStyles(styles)(ModalForm);



// WEBPACK FOOTER //
// ./src/components/Modals/ModalForm.js